import {ApplicationRef, Directive, DestroyRef, NgZone, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {fromEventPattern} from 'rxjs';
import i18next from 'i18next';


@Directive({
    selector: '[i18nRerenderOnLanguageChange]',
    standalone: true,
})
export class I18nRerenderOnLanguageChangeDirective {
    private readonly appRef = inject(ApplicationRef);
    private readonly zone = inject(NgZone);
    private readonly destroyRef = inject(DestroyRef);


    constructor() {
        fromEventPattern<string>(
            handler => i18next.on('languageChanged', handler),
            handler => i18next.off('languageChanged', handler)
        )
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.zone.run(() => this.appRef.tick());
            });
    }
}